import { Button } from "@/components/ui/button";
import { Ban, KeyRound, RotateCcw, ShieldCheck } from "lucide-react";
import { fmtDate, fmtDay, roleLabel } from "./format";

const Status = ({ a }) => {
  if (a.is_owner) return (
    <span className="inline-flex items-center gap-1 text-xs font-bold bg-lime-100 text-lime-800 px-2 py-1 rounded-full" data-testid={`owner-account-status-${a.id}`}>
      <ShieldCheck className="w-3 h-3" /> Owner · protected
    </span>
  );
  if (a.suspended) return (
    <div data-testid={`owner-account-status-${a.id}`}>
      <span className="text-xs font-bold bg-red-100 text-red-700 px-2 py-1 rounded-full">Suspended</span>
      <p className="text-xs text-slate-500 mt-1 max-w-[220px]">{a.suspension_reason} · {fmtDate(a.suspended_at)}</p>
    </div>
  );
  return <span className="text-xs font-semibold bg-slate-100 text-slate-600 px-2 py-1 rounded-full" data-testid={`owner-account-status-${a.id}`}>Active</span>;
};

export const AccountRow = ({ a, onAction }) => (
  <tr className="border-t border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`owner-account-row-${a.id}`}>
    <td className="px-4 py-3">
      <p className="font-semibold text-slate-900">{a.name}</p>
      <p className="text-xs text-slate-500 break-all">{a.email}</p>
    </td>
    <td className="px-4 py-3 text-sm text-slate-700">{roleLabel(a.role)}</td>
    <td className="px-4 py-3 text-sm text-slate-600">{a.company || "No company"}</td>
    <td className="px-4 py-3"><Status a={a} /></td>
    <td className="px-4 py-3 text-sm text-slate-500 whitespace-nowrap">{fmtDay(a.created_at)}</td>
    <td className="px-4 py-3">
      {!a.is_owner && (
        <div className="flex justify-end gap-2">
          {a.suspended ? (
            <Button size="sm" variant="outline" onClick={() => onAction("restore", a)} data-testid={`owner-restore-btn-${a.id}`}>
              <RotateCcw className="w-3.5 h-3.5 mr-1" /> Restore
            </Button>
          ) : (
            <>
              <Button size="sm" variant="outline" onClick={() => onAction("reset", a)} data-testid={`owner-reset-btn-${a.id}`}>
                <KeyRound className="w-3.5 h-3.5 mr-1" /> Email reset link
              </Button>
              <Button size="sm" variant="outline" className="text-red-600 border-red-200 hover:bg-red-50" onClick={() => onAction("suspend", a)} data-testid={`owner-suspend-btn-${a.id}`}>
                <Ban className="w-3.5 h-3.5 mr-1" /> Suspend
              </Button>
            </>
          )}
        </div>
      )}
    </td>
  </tr>
);
